import { jsx } from "react/jsx-runtime";
import { extend } from "@react-three/fiber";
import { MercatorCoordinate } from "mapbox-gl";
import { memo } from "react";
import { Layer } from "react-map-gl";
import * as THREE from "three";
import { useCanvas } from "./main8.mjs";
extend(THREE);
const fromLngLat = MercatorCoordinate.fromLngLat;
const Canvas = memo(({ id, beforeId, ...props }) => {
  const { id: reactId, onAdd, onRemove, render } = useCanvas({ ...props, fromLngLat });
  return /* @__PURE__ */ jsx(
    Layer,
    {
      id: id || reactId,
      beforeId,
      type: "custom",
      renderingMode: "3d",
      onAdd,
      onRemove,
      render
    }
  );
});
export {
  Canvas
};
//# sourceMappingURL=main4.mjs.map
